<template>
  <!-- prettier-ignore -->
  <div
    class="border p-2 w-full overflow-auto flex flex-row justify-between items-center bg-white 
    hover:bg-gray-200 transition-colors duration-300"
    :class="{ 'bg-secondary-pastel text-black hover:bg-gray-200 hover:text-black': rowIndex % 2 === 0 }">
    <button
      @click.prevent="handleContentClicked"
      class="w-2/3">
      <h2 class="text-lg font-medium text-light-grey">{{ sco.title }}</h2>
      <h3
        class="text-xs text-red-500"
        v-if="daysLeft && notFinished && !postTrainingDaysExpired">
        only {{ daysLeft }} day<template v-if="daysLeft > 1">s</template> left to take the assessment.
      </h3>
      <h3
        class="text-xs text-red-500"
        v-if="postTrainingDaysExpired">
        NO TIME LEFT - ASSESSMENT LOCKED OUT
      </h3>
    </button>
    <ul class="text-primary icon-row">
      <!-- <li v-if="feedbackAllowed" class="icon-list-item">
                <sco-user-feedback :sco="sco" class="icon-wrapper"></sco-user-feedback>
            </li> -->
      <li
        v-if="reportAllowed"
        class="icon-list-item">
        <sco-report
          :sco="sco"
          class="icon-wrapper"></sco-report>
      </li>
      <li
        v-if="certificateAllowed"
        class="icon-list-item">
        <sco-certificate
          :course-user-id="sco.course_user_id"
          class="icon-wrapper"></sco-certificate>
      </li>
      <li
        :title="statusText"
        class="icon-list-item">
        <router-link :to="{ name: 'Content', params: { scoUserId: sco.sco_user_id, slug } }">
          <div class="icon-wrapper">
            <component
              class="h-6"
              :is="statusIconComponentName"
              :class="{ 'text-secondary': statusIconComponentName === 'IconStarted' }" />
          </div>
        </router-link>
      </li>
      <li
        v-if="score"
        class="text-xs text-center">
        Score<br />{{ score }}%
      </li>
      <li
        v-if="certificateAllowed"
        class="text-xs text-center">
        {{ statusText }}<br />{{ dateFinished }}
      </li>
    </ul>
    <teleport to="body">
      <confirm-modal
        :is-visible="confirmModal.visible"
        :title="confirmModal.title"
        :message="confirmModal.message"
        :hide-cancel-button="true" 
        @confirm="confirmModal.visible=false"
        />
    </teleport>
  </div>
</template>

<script>
import ScoMixin from "@/components/courses/ScoMixin";

export default {
  name: "ScoRow",
  mixins: [ScoMixin],
  props: {
    rowIndex: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="postcss">
.icon-row li {
  display: inline-block;
  @apply ml-2;
}
.icon-row .icon-list-item {
  @apply mb-0;
}
</style>
